export default function getForexPrices(companies) {
  if (!companies || companies.length === 0) return {};

  const forexTickers = ["AUD", "BRL", "CNY", "EUR", "ZAR"];
  const rates = {};

  for (const ticker of forexTickers) {
    const match = companies.find(
      (c) => c.companyTicker === ticker && c.companyCurrency
    );
    if (match) {
      rates[ticker] = match.companyStockPrice;
    }
  }

  return rates;
}
